import React, { useState } from 'react';
import ReactImageFallback from 'react-image-fallback';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { Track } from 'angieslist-app-platform';
import { Button, Label } from 'angieslist-react-components';
import { get } from 'lodash';
import moment from 'moment';
import ReactTruncate from 'react-truncate';
import ShowcaseRemoveModal from './ShowcaseRemoveModal';
import { Showcase } from '../../common/profileService';
import './showcaseIndexCard.scss';

type Props = {
  showcase: Showcase,
  serviceProviderId: string | number,
  archiveShowcase: (showcaseId: number, serviceProviderId: string | number) => void,
  isLoading: boolean,
  isDraggable: boolean,
  labelText?: string,
  showDisplayButton?: boolean,
  shouldHideEdit: boolean,
  onDisplayButtonClick: (showcaseId: number) => void,
};

const ShowcaseIndexCard = ({
  showcase,
  serviceProviderId,
  archiveShowcase,
  isLoading,
  isDraggable,
  labelText,
  showDisplayButton,
  onDisplayButtonClick,
  shouldHideEdit,
}: Props) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const showModal = () => setModalVisible(true);
  const hideModal = () => setModalVisible(false);
  const fallbackImage = (
    <div className="showcase-index-card-image" />
  );

  const editShowcase = showcaseId => window.location.replace(`/app/showcase/${serviceProviderId}/${showcaseId}`);
  const displayShowcase = () => onDisplayButtonClick(showcase.showcaseId);

  const displayMediaUrl = get(showcase, 'displayMedia.url', '');
  const displayMediaUrlCORSsafe = `${displayMediaUrl}?q=${showcase.lastEdited}`;
  return (
    <Loader
      loading={isLoading}
      element={
        <div className="text-center" style={{ marginTop: '1em' }}>
          <i className="icon icon-load icon-spin icon-3x text-primary" />
        </div>}
    >
      <div className="showcase-index-card">
        <ShowcaseRemoveModal
          show={isModalVisible}
          onHide={hideModal}
          showcaseTitle={showcase.title}
          onRemoveShowcaseClick={() => archiveShowcase(showcase.showcaseId, serviceProviderId)}
          showcaseStatus={showcase.showcaseStatus}
        />
        <div id={`showcase-index-card-image-${showcase.showcaseId}`}>
          <If condition={labelText}>
            <Label className="showcase-label">{labelText}</Label>
          </If>
          <div className="image-wrapper">
            <If condition={showDisplayButton}>
              <div className="inactive-overlay" />
            </If>
            <If condition={isDraggable}>
              <div className="drag-overlay">
                <i className="icon icon-expand icon-3x" />
              </div>
            </If>
            <ReactImageFallback
              src={displayMediaUrlCORSsafe}
              alt={showcase.caption}
              fallbackImage={fallbackImage}
              className="showcase-index-card-image"
            />
          </div>
        </div>
        <div
          id={`showcase-index-card-title-${showcase.showcaseId}`}
          className="showcase-index-card-title-container"
        >
          <div className="showcase-index-card-title">
            <ReactTruncate lines={2}>{showcase.title}</ReactTruncate>
          </div>
          <div>
            <Choose>
              <When condition={showcase.showcaseStatus === 'Published'}>
                <div className="showcase-index-card-info">
                  <If condition={showcase.showcaseReviewStatus}>
                    <div className="showcase-index-card-verification">
                      <Choose>
                        <When condition={showcase.showcaseReviewStatus === 'Verified'}>
                          Homeowner Review Verified
                        </When>
                        <When condition={showcase.showcaseReviewStatus === 'Rejected'}>
                          Homeowner Review Rejected
                        </When>
                        <When condition={showcase.showcaseReviewStatus === 'ReviewRequested'}>
                          Review Requested
                        </When>
                        <Otherwise>
                          Homeowner Review Pending Verification
                        </Otherwise>
                      </Choose>
                    </div>
                  </If>
                  {showcase.mediaCount === 1 ? `${showcase.mediaCount} Photo` : `${showcase.mediaCount} Photos`}
                  <br />
                  {showcase.year}
                </div>
                <If condition={showDisplayButton}>
                  <div id="display-showcase-button">
                    <Track>
                      <Button
                        id={`showcase-index-card--display-button-${showcase.showcaseId}`}
                        data-track-activity-location={`SP : My Business : Showcase ${showcase.showcaseStatus === 'Published' ? 'Published' : 'Drafts'}`}
                        bsStyle="default-office"
                        block
                        bsSize="small"
                        className="text-info showcase-display-button"
                        onClick={displayShowcase}
                      >Display this Project
                      </Button>
                    </Track>
                  </div>
                </If>
              </When>
              <Otherwise>
                <div className="showcase-index-card-info">
                  {`Last saved ${moment(showcase.lastEdited).format('M/D/YYYY')}`}
                </div>
              </Otherwise>
            </Choose>
          </div>
        </div>
        <div className="showcase-index-card-button-row">
          {!shouldHideEdit &&
          <div id={`showcase-index-card-edit-section-left-${showcase.showcaseId}`} className="showcase-index-card-edit-section-left">
            <Track>
              <Button
                id={`showcase-index-card-edit-button-${showcase.showcaseId}`}
                data-track-activity-location={`SP : My Business : Showcase ${showcase.showcaseStatus === 'Published' ? 'Published' : 'Drafts'}`}
                bsStyle="link"
                bsSize="small"
                className="text-info"
                onClick={() => editShowcase(showcase.showcaseId)}
              >Edit
              </Button>
            </Track>
          </div>
          }
          <div id={`showcase-index-card-edit-section-right-${showcase.showcaseId}`} className="showcase-index-card-edit-section-right">
            <Track>
              <Button
                id={`showcase-index-card-remove-button-${showcase.showcaseId}`}
                data-track-activity-location={`SP : My Business : Showcase ${showcase.showcaseStatus === 'Published' ? 'Published' : 'Drafts'}`}
                bsStyle="link"
                bsSize="small"
                className="text-danger"
                onClick={showModal}
              >Delete
              </Button>
            </Track>
          </div>
        </div>
      </div>
    </Loader>
  );
};

export default ShowcaseIndexCard;



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ShowcaseIndexCard.js